<script setup lang="ts">
import MmDisclosure from '../base/MmDisclosure.vue'
const { t } = useI18n()
// Preserve the share route's existing crawlable destinations after removing
// its second, full-size footer. The share page keeps its own small footer.
const links = [
  ['/create', 'nav.createMusic'], ['/lyrics-generator', 'nav.lyricGenerator'],
  ['/rap-lyrics-generator', 'nav.rapLyric'], ['/rap-name-generator', 'nav.rapnameGenerator'],
  ['/album-cover-generator', 'nav.albumCover'], ['/mv-generator', 'nav.mvGenerator'],
  ['/clips', 'nav.clips'], ['/vocal-separation', 'nav.vocalSeparation'],
  ['/studio', 'mm.studio.allTools'], ['/library', 'nav.library'],
  ['/music', 't24a.chartsLabel'], ['/discover', 't24a.genres'],
  ['/feed', 'mm.feed.title'], ['/guides', 't24a.guides'],
  ['/pricing', 'nav.pricing'], ['/extension', 't24a.chromeExtension'],
  ['/about', 't24a.about'], ['/copyright', 't24a.copyright'],
  ['/data-deletion.html', 't24a.dataDeletion'],
]
</script>

<template>
  <nav class="share-discovery mm-root" :aria-label="t('mm.shell.exploreMusicMint')">
    <MmDisclosure :label="t('mm.shell.exploreMusicMint')">
      <div class="cluster"><NuxtLink v-for="[to, key] in links" :key="to" class="btn btn-ghost btn-sm" :to="to">{{ t(key) }}</NuxtLink></div>
    </MmDisclosure>
  </nav>
</template>

<style scoped>
.share-discovery { max-width: 980px; margin: 0 auto; padding: 0 var(--gutter) var(--s-6); }
</style>
